import { render, staticRenderFns } from "./NpsStats.vue?vue&type=template&id=1a0de97d&scoped=true"
import script from "./NpsStats.vue?vue&type=script&lang=js"
export * from "./NpsStats.vue?vue&type=script&lang=js"
import style0 from "./NpsStats.vue?vue&type=style&index=0&id=1a0de97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0de97d",
  null
  
)

export default component.exports